"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSuiStyles = void 0;
var _AppMediaProvider = require("baseStyles/AppMediaProvider");
var _ThemeProvider = require("baseStyles/ThemeProvider");
var _device = _interopRequireDefault(require("baseStyles/enums/device"));
var _react = require("react");
var _data = _interopRequireDefault(require("utility/data"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var mediaStyleOrder = [_device["default"].types.Desktop, _device["default"].types.Tablet, _device["default"].types.Mobile, _device["default"].types.Mobile];
var useSuiStyles = exports.useSuiStyles = function useSuiStyles(styles) {
  // console.log("useSuiStyles Init");

  return function (props) {
    var _useAppMediaProvider = (0, _AppMediaProvider.useAppMediaProvider)(),
      currentDevice = _useAppMediaProvider.currentDevice;
    var _useSuiTheme = (0, _ThemeProvider.useSuiTheme)(),
      theme = _useSuiTheme.theme,
      themeName = _useSuiTheme.themeName;

    // console.log("useSuiStyles", props, currentDevice, theme, themeName);

    var desktopStyles = (0, _react.useMemo)(function () {
      var _styles$desktop;
      return (_styles$desktop = styles.desktop) === null || _styles$desktop === void 0 ? void 0 : _styles$desktop.call(styles, _objectSpread(_objectSpread({}, props), {}, {
        theme: theme,
        themeName: themeName
      }));
    }, [props, theme, currentDevice]);
    var currentDeviceStyles = (0, _react.useMemo)(function () {
      var _styles$currentDevice;
      return (_styles$currentDevice = styles[currentDevice]) === null || _styles$currentDevice === void 0 ? void 0 : _styles$currentDevice.call(styles, _objectSpread(_objectSpread({}, props), {}, {
        theme: theme,
        themeName: themeName
      }));
    }, [props, theme, currentDevice]);
    var finalStyles = (0, _react.useMemo)(function () {
      var currentOrder = mediaStyleOrder.findIndex(function (item) {
        return item === currentDevice;
      });
      var data = desktopStyles;
      for (var i = 1; i <= currentOrder; i++) {
        var _styles$mediaStyleOrd;
        data = _data["default"].deepMerge(data, (_styles$mediaStyleOrd = styles[mediaStyleOrder[i]]) === null || _styles$mediaStyleOrd === void 0 ? void 0 : _styles$mediaStyleOrd.call(styles, _objectSpread(_objectSpread({}, props), {}, {
          theme: theme,
          themeName: themeName
        })));
      }
      return data;
    }, [desktopStyles, currentDeviceStyles]);
    return finalStyles;
  };
};